import { render, staticRenderFns } from "./PosterDetail.vue?vue&type=template&id=9217bb34&scoped=true&"
import script from "./PosterDetail.vue?vue&type=script&lang=js&"
export * from "./PosterDetail.vue?vue&type=script&lang=js&"
import style0 from "./PosterDetail.vue?vue&type=style&index=0&id=9217bb34&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9217bb34",
  null
  
)

export default component.exports